export { default } from "./articleTypes.constants";
export type { ArticleType } from "./articleTypes.constants";
